import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import ChatForm from "./ChatForm";
import ChatMessages from "./ChatMessages";
import ChatsList from "./ChatsList";
export default class Chat extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      chatId: null,
      pending: false,
      messages: [
        {
          id: 10,
          author: "Кто-то",
          date: new Date(),
          text: "Привет! Ну как там проект",
        },
        {
          id: 20,
          author: "Вы",
          right: true,
          date: new Date(),
          text: "Все хорошо",
        },
      ],
      chats: [
        {
          id: "ivan",
          name: "Иванов Иван",
        },
        {
          id: "group",
          name: "Отдел снабжения",
          new: true,
        },
      ],
    };
  }
  componentDidMount() {
    this.initRouteState();
    this.renderButtons();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.urlParam1 !== this.props.urlParam1) {
      this.initRouteState();
    }
    this.renderButtons();
  }

  renderButtons = () => {
    this.context.actionsSet(<></>);
  };

  initRouteState = () => {
    const param = this.props.urlParam1;
    this.setState({ chatId: param });
  };

  onSend = (message) => {
    let { messages } = this.state;
    messages.push({
      id: message,
      author: "Вы",
      right: true,
      date: new Date(),
      text: message,
    });
    this.setState({ messages });
  };

  render() {
    return (
      <>
        <CrumbsProvider title="Личные сообщения" />
        <Blocker on={this.state.pending}>
          <div className="row h-100">
            <div className={`col-lg-4 no-print border-right`}>
              <ChatsList chats={this.state.chats} chatId={this.state.chatId} />
            </div>
            <div className="col h-100  d-flex flex-column justify-content-center">
              {this.state.chatId ? (
                <>
                  <div className="flex-grow-1 py-3">
                    <ChatMessages messages={this.state.messages} />
                  </div>
                  <div>
                    <ChatForm onSend={this.onSend} />
                  </div>
                </>
              ) : (
                <>
                  <div className="h4 text-center text-muted">
                    Выберите собеседника
                  </div>
                </>
              )}
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
